import { ObjectHelper } from "../../utils/helpers";
import { MessageSeverity } from "../../utils/lib/messageSeverity";

export interface VfxSnackbarProps {
    open: boolean;
    message: string | null;
    severity: MessageSeverity;
    autoHideDuration: number;
    handleClose: () => void;
}

export function SetSnackbarPropss(props: VfxSnackbarProps) {
    ObjectHelper.CheckValue<boolean>(props.open, false);
    ObjectHelper.CheckValue<string | null>(props.message, null);
    ObjectHelper.CheckValue<MessageSeverity>(props.severity, MessageSeverity.Error);
    ObjectHelper.CheckValue<number>(props.autoHideDuration, 10000);
}